import type { NextRouter } from 'next/router';
import { TypeHolidayBundlesCardFields } from '@/core/generated-types';
import { ShopifyVariant } from '@/lib/shopify';
import { ITEM_ORIGINS } from '@/core/constants';
import { ShopifyProductType } from '@/lib/shopify';
import { CartLineInput } from '@/lib/shopify';

export const getBundleAvailability = (
  includes: TypeHolidayBundlesCardFields['includes'],
) => {
  return includes
    .filter((item) => item.sys.contentType.sys.id === 'product') // Filter only products
    .some((product) => {
      const variants = product.fields.shopifyProduct?.variants;
      if (variants && variants.length === 1) {
        // Single variant case
        return !variants[0].availableForSale;
      } else {
        // Multiple variants case
        return variants
          ? variants.every(
              (variant: ShopifyVariant) => !variant.availableForSale,
            )
          : null;
      }
    });
};

export const generateCartItems = (
  includes: TypeHolidayBundlesCardFields['includes'],
  quantity: number,
): CartLineInput[] => {
  return includes
    .filter(
      (item: any) =>
        item.sys.contentType.sys.id === 'product' &&
        !item.fields.isPlayKit &&
        !item.fields.shopifyProduct?.tags.includes('the-play-kitchen'),
    )
    .map((item: any) => {
      const isSkillSet =
        item.fields.shopifyProduct?.productType ===
        ShopifyProductType.SKILL_SET;
      const isCoursePack =
        item.fields.shopifyProduct?.productType === ShopifyProductType.COURSE;
      return {
        merchandiseId: item.fields.shopifyProduct.variants[0].id,
        quantity,
        attributes: [
          { key: 'item_origin', value: ITEM_ORIGINS.PRODUCT_PAGE },
          {
            key: 'quantity_limited_to_one',
            value: String(isCoursePack || isSkillSet),
          },
          { key: 'is_course_pack', value: String(isCoursePack) },
          { key: 'is_skill_set', value: String(isSkillSet) },
        ],
      };
    });
};

export const generatePlayKitchenItem = (
  selectedVariant: ShopifyVariant,
  quantity: number,
) => ({
  merchandiseId: selectedVariant?.id || '',
  quantity,
  attributes: [
    { key: 'item_origin', value: ITEM_ORIGINS.PRODUCT_PAGE },
    { key: 'quantity_limited_to_one', value: 'false' },
  ],
});

export const redirectAfterAddToCart = async (
  router: NextRouter,
  includePlayKits: TypeHolidayBundlesCardFields['includePlayKits'],
  includeBookBundles: TypeHolidayBundlesCardFields['includeBookBundles'],
) => {
  if (includePlayKits) {
    router.push(
      `/pages/subscription-v3/child-info?simplifiedSubflow=true&size=${includePlayKits}&addOns=${includeBookBundles}`,
    );
  } else {
    window.location.href = '/cart';
  }
};
